import { render, staticRenderFns } from "./completed-details.vue?vue&type=template&id=00724de3&"
import script from "./completed-details.vue?vue&type=script&lang=js&"
export * from "./completed-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports